import React, { useState, useContext } from "react";
import { Slide, SlideImage, SliderContainer, Tag } from "./styles";
import assets from "../../assets";
import { ThemeContext } from "../../contexts/ThemeContext";

const ImageSlider = ({ slides }: any) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState<number | null>(null);

  const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { themeMode } = themeContext;

  const placeholderImage =
    themeMode === "dark"
      ? assets.imagePlaceholderDark
      : assets.imagePlaceholderWhite;

  // Function to go to the next slide
  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  // Function to go to the previous slide
  const goToPrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + slides.length) % slides.length
    );
  };

  // Handle swipe start
  const handleTouchStart = (e: React.TouchEvent) => {
    setStartX(e.touches[0].clientX);
  };

  // Handle swipe move
  const handleTouchMove = (e: React.TouchEvent) => {
    if (startX === null) return;
    const endX = e.touches[0].clientX;
    const difference = startX - endX;

    if (Math.abs(difference) > 50) {
      if (difference > 0) {
        goToNext(); // Swipe left
      } else {
        goToPrevious(); // Swipe right
      }
      setStartX(null); // Reset after swipe
    }
  };

  // Handle swipe end
  const handleTouchEnd = () => {
    setStartX(null);
  };

  const getSlidesLength = slides.length;

  return (
    <SliderContainer
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {slides.map(
        (
          slide: { image: { urls: { big: string | undefined } }; caption: any },
          index: React.Key | null | undefined
        ) => (
          <Slide key={index} isActive={index === currentIndex}>
            {index === currentIndex && (
              <SlideImage
                src={slide.image.urls.big || placeholderImage}
                alt={slide.caption || `Slide ${index + 1}`}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = placeholderImage;
                }}
              />
            )}
            <Tag>
              {currentIndex + 1} / {getSlidesLength}
            </Tag>
          </Slide>
        )
      )}
    </SliderContainer>
  );
};

export default ImageSlider;
